import React, { memo, FC, CSSProperties } from 'react';
import styled from '@emotion/styled';
import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { MathJax } from 'better-react-mathjax';
import { useTranslation } from 'react-i18next';

import FormulaImages from '@/images/formula.svg';

const targetHandleStyle: CSSProperties = { background: 'transparent' };
const targetHandleStyleL: CSSProperties = {
  ...targetHandleStyle,
  background: 'transparent',
  // left: -15,
  // top: '59px',
};
const sourceHandleStyleA: CSSProperties = { ...targetHandleStyle };
const sourceHandleStyleB: CSSProperties = { ...targetHandleStyle };

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Box = styled.div`
  background: #f8cecc;
  border: solid 1px #b85450;
  margin: 5px;
  width: 230px;
  height: 81px;
  padding: 14px 8px;
  text-align: center;
`;

const Formula: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  // const f =
  //   '\\(\\propto \\dfrac{P_e \\: P_c}{P_d^\\alpha \\: P_m^\\beta \\: P_o^\\gamma} \\cdot \\pi \\)';
  return (
    <Box>
      <Handle
        type="target"
        id="Formula-Target-T"
        position={Position.Top}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <Handle
        type="target"
        id="Formula-Target-L"
        position={Position.Left}
        style={targetHandleStyleL}
        onConnect={onConnect}
      >
        {/* <div style={{ height: '204px', borderLeft: '1px solid',margin:'3px 0 0 -1px' }}></div> */}
      </Handle>
      <Handle
        type="target"
        id="Formula-Target-B"
        position={Position.Bottom}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <div>
        <div style={{ marginBottom: 8, whiteSpace: 'nowrap' }}>
          {t('SurgeryProbability')}
        </div>
        <span style={{ fontSize: 16 }}>
          {/* <MathJax>{f}</MathJax> */}
          α (ρ<sub>p|s,X</sub>)
          <sup>
            a<sub>p</sub>
          </sup>{' '}
          . (ρ<sub>e|s,X</sub>)
          <sup>
            a<sub>e</sub>
          </sup>{' '}
          . (ρ<sub>r|s,X</sub>)
          <sup>
            a<sub>r</sub>
          </sup>{' '}
          . (ρ<sub>c|s,X</sub>)
          <sup>
            a<sub>c</sub>
          </sup>{' '}
          . (ρ<sub>o|s,X</sub>)
          <sup>
            a<sub>o</sub>
          </sup>
          {/* α (ρb|s,X)ab * (ρe|s,X)ae * (ρr|s,X)ar * (ρc|s,X)ac * (ρo|s,X)ao */}
          {/* <FormulaImages /> */}
        </span>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="Formula-Source-R"
        style={sourceHandleStyleB}
        isConnectable={isConnectable}
      />
    </Box>
  );
};

export default memo(Formula);
